import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
/**
 * Generated class for the DurationConverterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'durationConverter',
})
export class DurationConverterPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, segmentSizeInMinutes?: any, segmentsPerBlock?: any, startTime?:string, endTime?:string) {
    let newString: string = "";

    if (value === 'Per block') {
      let bookingTime = segmentsPerBlock * segmentSizeInMinutes;
      let hour, minute;

      hour = Math.floor(bookingTime / 60);
      minute = bookingTime;

      if (hour > 0) {
        minute = minute - (hour * 60);
      }

      let finalString: string = "";

      if (hour === 1) {
        finalString = "1 hour";
      }
      else if (hour > 1) {
        finalString = `${hour} hours`;
      }

      if (minute === 1) {
        if (finalString === "") {
          finalString = "1 minute";
        }
        else {
          finalString += " 1 minute";
        }
      }
      else if (minute > 1) {
        if (finalString === "") {
          finalString = `${minute} minutes`;
        }
        else {
          finalString += ` ${minute} minutes`;
        }
      }
      newString = finalString;
    } else if (value === 'Per booking') {
      return value;
    } else if (value === 'standard') {
      let bookingTime = moment(endTime).diff(startTime, "minutes");
      let hour, minute;

      hour = Math.floor(bookingTime / 60);
      minute = bookingTime;

      if (hour > 0) {
        minute = minute - (hour * 60);
      }

      let finalString: string = "";

      if (hour === 1) {
        finalString = "1 Hour";
      }
      else if (hour > 1) {
        finalString = `${hour} Hours`;
      }

      if (minute === 1) {
        if (finalString === "") {
          finalString = "1 Minute";
        }
        else {
          finalString += " 1 Minute";
        }
      }
      else if (minute > 1) {
        if (finalString === "") {
          finalString = `${minute} Minutes`;
        }
        else {
          finalString += ` ${minute} Minutes`;
        }
      }
      newString = finalString;
    }

    return newString;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/duration-converter/duration-converter.ts